export default "__VITE_ASSET__DSYp3Dic__"